import React from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

export const LoaderView = ({ visible = false, height = 40, width = 40, color = "orange" }) => {
  if (!visible) return null;
  return (
    <div className="loader">
      <Loader type={"Oval"} visible={visible} color={color} height={height} width={width} />
    </div>
  );
};
